(function () {
  'use strict';

  function initConnectionPage(root) {
    if (!root || root.dataset.mecdrReady === 'true') return;

    var search = root.querySelector('[data-provider-search]');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-provider-option]'));
    var propertyButtons = Array.prototype.slice.call(root.querySelectorAll('[data-property-type]'));
    var status = root.querySelector('[data-provider-status]');
    var empty = root.querySelector('[data-provider-empty]');
    var actionTitle = root.querySelector('[data-action-title]');
    var disabledAction = root.querySelector('[data-action-disabled]');
    var actionLink = root.querySelector('[data-action-link]');
    if (!search || !status || !empty || !actionTitle || !disabledAction || !actionLink || !options.length || !propertyButtons.length) return;

    root.dataset.mecdrReady = 'true';
    var contactEmail = root.dataset.contactEmail || 'sales@moebotics.ai';
    var selectedProvider = '';
    var propertyType = 'home';

    function buildEmailHref() {
      var subject = 'Join Moebotics Energy secure data-connection updates';
      var body = [
        'Please add me to Moebotics Energy\u2019s secure energy-data connection launch updates.',
        '',
        'Property: ' + propertyType,
        'Electricity retailer: ' + selectedProvider,
        '',
        'When eligible connections open, I understand that authorisation will occur through a secure consent flow. I will keep credentials, account numbers and bills within the secure pathway.'
      ].join('\n');
      return 'mailto:' + contactEmail + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    }

    function updateAction() {
      if (selectedProvider) {
        actionTitle.textContent = 'Join launch updates for ' + selectedProvider;
        actionLink.href = buildEmailHref();
        actionLink.hidden = false;
        disabledAction.hidden = true;
      } else {
        actionTitle.textContent = 'Select a retailer to join the launch list';
        actionLink.hidden = true;
        actionLink.removeAttribute('href');
        disabledAction.hidden = false;
      }
    }

    function selectProvider(option) {
      selectedProvider = option.dataset.providerName || '';
      options.forEach(function (item) {
        var isSelected = item === option;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        item.tabIndex = isSelected ? 0 : -1;
      });
      updateAction();
    }

    function visibleOptions() {
      return options.filter(function (option) { return !option.hidden; });
    }

    function setProviderTabStop() {
      var visible = visibleOptions();
      var selected = visible.find(function (option) { return option.dataset.providerName === selectedProvider; });
      var target = selected || visible[0];
      options.forEach(function (option) { option.tabIndex = option === target ? 0 : -1; });
    }

    function filterProviders() {
      var query = (search.value || '').trim().toLocaleLowerCase('en-AU');
      var shown = 0;
      var selectedStillVisible = false;

      options.forEach(function (option) {
        var name = (option.dataset.providerName || '').toLocaleLowerCase('en-AU');
        var visible = !query || name.indexOf(query) !== -1;
        option.hidden = !visible;
        if (visible) shown += 1;
        if (visible && option.dataset.providerName === selectedProvider) selectedStillVisible = true;
      });

      if (selectedProvider && !selectedStillVisible) {
        selectedProvider = '';
        options.forEach(function (option) {
          option.classList.remove('is-selected');
          option.setAttribute('aria-checked', 'false');
        });
        updateAction();
      }

      setProviderTabStop();
      status.textContent = shown + (shown === 1 ? ' retailer example shown.' : ' retailer examples shown.');
      empty.hidden = shown !== 0;
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () { selectProvider(option); });
      option.addEventListener('keydown', function (event) {
        var visible = visibleOptions();
        var current = visible.indexOf(option);
        var next = current;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % visible.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + visible.length) % visible.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = visible.length - 1;
        else return;
        event.preventDefault();
        if (!visible[next]) return;
        selectProvider(visible[next]);
        visible[next].focus();
      });
    });

    propertyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        propertyType = button.dataset.propertyType || 'home';
        propertyButtons.forEach(function (item) {
          var isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        if (selectedProvider) actionLink.href = buildEmailHref();
      });
    });

    search.addEventListener('input', filterProviders);
    setProviderTabStop();
  }

  function initAll() {
    document.querySelectorAll('[data-mecdr-root]').forEach(initConnectionPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mecdr-root]');
    if (root) initConnectionPage(root);
  });
})();
